import { render, staticRenderFns } from "./IntroSection.vue?vue&type=template&id=22b491d2&scoped=true&"
var script = {}
import style0 from "./IntroSection.vue?vue&type=style&index=0&id=22b491d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b491d2",
  null
  
)

export default component.exports